import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { useQueryParams, makeQueryStrings } from '../utils/queryParams';
import {
  addErrorMessage,
  setOnCloseErrorModal,
  setSessionKey,
} from '../modules/app';
import { saveSelectedParts } from '../utils/localStorage';
import {
  handleQueryParamsFlight,
  setQueryParamsValidatedFlight,
  fetchEssentialFlightStateFromSession,
} from '../modules/flight';
import {
  handleQueryParamsHotel,
  setQueryParamsValidatedHotel,
  fetchEssentialHotelStateFromSession,
} from '../modules/hotel';
import {
  handleQueryParamsPlanList,
} from '../modules/plan';
import {
  handleQueryParamsPlanDetail,
  handleQueryParamsEntryConfirm,
} from '../modules/planDetail';
import {
  handleQueryParamsPlanOption,
} from '../modules/planOptions';
import Loading from './atoms/Loading';
import { createKeybyTimestamp, validateSessionkey } from '../utils/localStorage';
import { ERROR_STATUS_MESSAGE_MAP, BASENAME } from '../constants';

const selector = (state) => ({
  flight: state.flight,
  hotel: state.hotel,
});

const normalizeParts = (value) => {
  if (value == null) return undefined;
  const str = String(value);
  if (!str || str === 'undefined' || str === 'null') return undefined;
  // 想定外の値はヘッダ切替対象外として無視（必要なら許容値を追加）
  if (str !== 'tbw' && str !== 'wst') return undefined;
  return str;
};

const QueryParams = () => {
  const history = useHistory();
  const location = useLocation();
  const { flight, hotel } = useSelector(selector);
  const {
    queryParamsValidated: queryParamsValidatedFlight,
  } = flight;
  const {
    queryParamsValidated: queryParamsValidatedHotel,
  } = hotel;

  const query = useQueryParams();
  const dispatch = useDispatch();

  const { pathname } = location;

  // handle k(=sessionKey)
  let { k, error: errorStatus, errorMsg } = query;

  useEffect(() => {

    if (errorStatus) {
      const errorMessage = (errorStatus === '999') ? (errorMsg || ERROR_STATUS_MESSAGE_MAP.fallback) : (ERROR_STATUS_MESSAGE_MAP[errorStatus] || ERROR_STATUS_MESSAGE_MAP.fallback);
      dispatch(addErrorMessage(errorMessage));
      const searchParams = { ...query };
      delete searchParams.error;
      delete searchParams.errorMsg;
      const searchString = makeQueryStrings(searchParams);
      const topUrl = `${BASENAME}/search${searchString ? `?${searchString}` : ''}`;
      dispatch(setOnCloseErrorModal(
        () => window.open(topUrl, '_self')
      ));
      return;
    }

    if (k) {
      if (pathname !== '/search' && pathname !== '/searcha') {
        if (!validateSessionkey(k)) {
          history.push('/timeout');
          return;
        }

        dispatch(fetchEssentialFlightStateFromSession(k));
        dispatch(fetchEssentialHotelStateFromSession(k));
      }
    } else {
      k = createKeybyTimestamp();
    }
    setSessionKey(k);

    // handle Parts
    // /search(/a) でのみ URL の Parts を永続化し、以降のページでは storage の値を利用する
    if (pathname === '/search' || pathname === '/searcha') {
      const parts = normalizeParts(query.Parts);
      if (parts !== undefined) {
        saveSelectedParts(k, parts);
      }
    }

    switch (pathname) {

    case '/search': {
      dispatch(handleQueryParamsFlight(query));
      dispatch(handleQueryParamsHotel(query));
      break;
    }

    case '/searcha': {
      dispatch(handleQueryParamsFlight(query));
      dispatch(handleQueryParamsHotel(query));
      break;
    }

    case '/plan_list': {
      dispatch(handleQueryParamsPlanList(query));
      dispatch(setQueryParamsValidatedFlight(true));
      dispatch(setQueryParamsValidatedHotel(true));
      break;
    }

    case '/plan_detail': {
      dispatch(handleQueryParamsPlanDetail(query));
      dispatch(setQueryParamsValidatedFlight(true));
      dispatch(setQueryParamsValidatedHotel(true));
      break;
    }

    case '/plan_option': {
      dispatch(handleQueryParamsPlanOption(query));
      dispatch(setQueryParamsValidatedFlight(true));
      dispatch(setQueryParamsValidatedHotel(true));
      break;
    }

    case '/entry_confirm': {
      dispatch(handleQueryParamsEntryConfirm(query));
      dispatch(setQueryParamsValidatedFlight(true));
      dispatch(setQueryParamsValidatedHotel(true));
      break;
    }

    default: {
      dispatch(setQueryParamsValidatedFlight(true));
      dispatch(setQueryParamsValidatedHotel(true));
      break;
    }
    }
  }, [pathname, location.search]);

  if (!errorStatus && !(queryParamsValidatedFlight && queryParamsValidatedHotel)) {
    return (
      <Loading show progressRate={0} />
    );
  }

  return null;

};

export default QueryParams;
